import update from "immutability-helper";
import type { AnyAction } from "redux";

import {
  PROJECT_UPLOADING_SET_FILES,
  PROJECT_UPLOADING_SET_PROGRESS_LOCAL_FILES,
  PROJECT_UPLOADING_SET_COMPLETE_LOCAL_FILES,
  PROJECT_UPLOADING_SET_PROGRESS_CLOUD_FILES,
  PROJECT_UPLOADING_DELETE_FILES,
  PROJECT_UPLOADING_BULK_UPDATE_FILES,
  PROJECT_UPLOADING_HYDRATE_METADATA,
  PROJECT_SET_NEED_TO_DELETE_FLAG,
  GET_UPDATE_FILES,
  ADD_FILE,
} from "../actions/types";

export enum UploadType {
  Local = "local",
  Cloud = "cloud",
}
export type StoriesToUploadCloud = {
  storyId: string;
  title: string;
  recordDate: string;
  // story: Story;
  type: UploadType.Cloud;
};

export type StoriesToUploadLocal = {
  story: any;
  storyId: string;
  uploadProgress: number;
  uploadedPartCount: number;
  file: File;
  fileType: string;
  type: UploadType.Local;
  complete: boolean;
};

export type File = {
  _id: string;
  created_at: Date;
  description: string;
  altText: string;
  credit: string;
  release_form: boolean;
  mediaType: string;
  fileType: string;
  title: string;
  url: string;
  uploadedBy: string;
  creator: any;
};

export type FileUploadState = {
  uploadingFiles: boolean;
  current: number;
  total: number;
  filesCompleted: number;
  stories: StoriesToUploadLocal[] | StoriesToUploadCloud[];
  projectId: null;
  folderId: string | null;
  folders: string[];
  filesTab: File[];
};

const initialState: FileUploadState = {
  uploadingFiles: false,
  filesCompleted: 0,
  current: 0,
  total: 0,
  stories: [],
  projectId: null,
  folderId: null,
  folders: [],
  filesTab: [],
};

const uploadFilesReducer = (state = initialState, { type, payload }: AnyAction) => {
  switch (type) {
    case PROJECT_UPLOADING_SET_FILES:
      return update(state, {
        stories: { $set: payload.filesToUpload },
        uploadingFiles: { $set: true },
        total: { $set: payload.total },
        projectId: { $set: payload.projectId },
        folderId: { $set: payload.folderId || null },
        folders: { $set: payload.folders },
      });

    case PROJECT_UPLOADING_SET_PROGRESS_LOCAL_FILES:
      return update(state, {
        stories: { $set: payload.updatedStories },
        current: { $set: payload.current },
        filesCompleted: { $set: payload.filesCompleted },
      });

    case PROJECT_UPLOADING_SET_PROGRESS_CLOUD_FILES:
      return update(state, {
        stories: { $set: payload.updatedStories },
        filesCompleted: { $set: payload.filesCompleted },
        uploadingFiles: { $set: payload.uploadingFiles },
        total: { $set: payload.total },
        projectId: { $set: payload.projectId },
      });

    case PROJECT_UPLOADING_SET_COMPLETE_LOCAL_FILES:
      return update(state, {
        stories: { $set: payload.updatedStories },
        uploadingFiles: { $set: payload.uploadingFiles },
      });

    case PROJECT_UPLOADING_BULK_UPDATE_FILES:
      return update(state, {
        stories: { $set: payload.stories },
      });

    case PROJECT_UPLOADING_HYDRATE_METADATA:
      return update(state, {
        stories: { $set: payload.stories },
      });

    case PROJECT_UPLOADING_DELETE_FILES:
      return update(state, {
        stories: { $set: payload.updatedStories },
        filesCompleted: { $set: payload.filesCompleted },
        uploadingFiles: { $set: payload.uploadingFiles },
        total: { $set: payload.total },
      });
    case PROJECT_SET_NEED_TO_DELETE_FLAG:
      return update(state, {
        stories: { $set: payload.updatedStories },
      });
    case GET_UPDATE_FILES:
      return update(state, {
        filesTab: { $set: payload.files },
      });
    case ADD_FILE:
      return update(state, {
        filesTab: { $set: [payload.file, ...state.filesTab] },
      });

    default:
      return state;
  }
};

export default uploadFilesReducer;
